import { Plane } from "lucide-react";

const COLUMNS = [
  {
    title: "Product",
    links: ["Pre-Travel Requests", "Policy Engine", "Expense Settlement", "Cash Advances", "Analytics"],
  },
  {
    title: "Roles",
    links: ["Employees", "Managers", "Travel Desk", "Finance & Audit"],
  },
  {
    title: "Integrations",
    links: ["SAP & Oracle", "Tally", "Workday & BambooHR", "Amadeus & Sabre"],
  },
  {
    title: "Company",
    links: ["Security & SOC 2", "GDPR & Privacy", "Careers", "Contact"],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#090d16] noise-bg border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-10">
        <div className="grid md:grid-cols-[1.2fr_2fr] gap-14">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-8 h-8 rounded-md bg-blue-600 flex items-center justify-center">
                <Plane className="w-4 h-4 text-white" />
              </span>
              <span className="font-heading font-bold text-lg text-white">CTEMS</span>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
              Autonomous policy & expense intelligence for global enterprises — from the first travel request to the final ERP posting.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
            {COLUMNS.map((c) => (
              <div key={c.title}>
                <p className="font-mono text-[11px] tracking-widest text-slate-500 uppercase">{c.title}</p>
                <ul className="mt-4 space-y-2.5">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="text-sm text-slate-400 hover:text-white transition-colors duration-200">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-20 font-heading font-extrabold text-outline text-[13vw] leading-none text-center select-none">
          CTEMS
        </p>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© 2026 CTEMS Inc. All rights reserved.</p>
          <div className="flex gap-6">
            {["Terms", "Privacy", "Security"].map((l) => (
              <a key={l} href="#top" className="text-xs text-slate-500 hover:text-white transition-colors duration-200">
                {l}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
